import { CLEAR_APPLICATION_DATA, SAVE_DEGREE_INFO } from "../constant";

export const degreeApplicationInitialState = (data) => {
	return {
		personalInfoResponse: {
			id: data?.personalInfoResponse?.id ?? null,
			PassportAsBase64: data?.passport,
			regNumber: data?.regNumber,
			surname: data?.personalInfoResponse?.surname,
			firstname: data?.personalInfoResponse?.firstname,
			lastname: data?.personalInfoResponse?.lastname,
			middlename: data?.personalInfoResponse?.middlename,
			homeTown: data?.personalInfoResponse?.homeTown,
			disability: data?.personalInfoResponse?.disability,
			nin: data?.nin,
			otherNames: data?.personalInfoResponse?.otherNames,
			...(data?.personalInfoResponse?.genderId && {
				genderId: {
					value: data?.personalInfoResponse?.genderId,
					label: data?.personalInfoResponse?.gender
				}
			}),
			dateOfBirth: data?.personalInfoResponse?.dateOfBirth,
			...(data?.personalInfoResponse?.country && {
				countryId: {
					value: data?.personalInfoResponse?.countryId,
					label: data?.personalInfoResponse?.country
				}
			}),
			...(data?.personalInfoResponse?.state && {
				stateId: {
					value: data?.personalInfoResponse?.stateId,
					label: data?.personalInfoResponse?.state
				}
			}),
			...(data?.personalInfoResponse?.lga && {
				lgaId: {
					value: data?.personalInfoResponse?.lgaId,
					label: data?.personalInfoResponse?.lga
				}
			}),
			permanentAddress: data?.personalInfoResponse?.permanentAddress,
			contactAddress: data?.personalInfoResponse?.contactAddress,
			mobileNumber: data?.personalInfoResponse?.mobileNumber,
			...(data?.personalInfoResponse?.religionId && {
				religionId: {
					value: data?.personalInfoResponse?.religionId,
					label: data?.personalInfoResponse?.religion
				}
			}),
			email: data?.personalInfoResponse?.email,
			numberOfChildren: data?.personalInfoResponse?.numberOfChildren,
			...(data?.personalInfoResponse?.maritalStatusId && {
				maritalStatusId: {
					value: data?.personalInfoResponse?.maritalStatusId,
					label: data?.personalInfoResponse?.maritalStatus
				}
			})
		},
		nextOfKin: {
			fullname: data?.personalInfoResponse?.sponsorFullName,
			...(data?.personalInfoResponse?.sponsorRelationshipId && {
				relationshipId: {
					value: data?.personalInfoResponse?.sponsorRelationshipId,
					label: data?.personalInfoResponse?.sponsorRelationship
				}
			}),
			mobileNumber: data?.personalInfoResponse?.sponsorMobileNumber,
			address: data?.personalInfoResponse?.sponsorContactAddress
		},
		programmeInfo: {
			applicationType: data?.applicationType ?? null,
			applicationTypeId: data?.applicationTypeId ?? null,
			rrr: data?.programmeInfoResponse?.rrr ?? null,

			facultyId:
				data?.programmeInfoResponse?.facultyId != null
					? {
							value: data.programmeInfoResponse.facultyId,
							label: data.programmeInfoResponse.faculty
					  }
					: null,
			alternateFacultyId:
				data?.programmeInfoResponse?.alternateFacultyId != null
					? {
							value: data.programmeInfoResponse
								.alternateFacultyId,
							label: data.programmeInfoResponse.alternateFaculty
					  }
					: null,

			departmentId:
				data?.programmeInfoResponse?.departmentId != null
					? {
							value: data.programmeInfoResponse.departmentId,
							label: data.programmeInfoResponse.department
					  }
					: null,
			programmeCategoryId:
				data?.programmeInfoResponse?.programmeCategoryId != null
					? {
							value: data.programmeInfoResponse
								.programmeCategoryId,
							label: data.programmeInfoResponse.programmeCategory
					  }
					: null,
			programmeTypesId:
				data?.programmeInfoResponse?.programmeTypesId != null
					? {
							value: data.programmeInfoResponse.programmeTypesId,
							label: data.programmeInfoResponse.programmeTypes
					  }
					: null,
			alternativeDepartmentId:
				data?.programmeInfoResponse?.alternativeDepartmentId != null
					? {
							value: data.programmeInfoResponse
								.alternativeDepartmentId,
							label: data.programmeInfoResponse
								.alternativeDepartment
					  }
					: null,

			jambNumber: data?.regNumber,

			departmentOptionId:
				data?.programmeInfoResponse?.departmentOptionId != null
					? {
							value: data.programmeInfoResponse
								.departmentOptionId,
							label: data.programmeInfoResponse.departmentOption
					  }
					: null,

			programmeId:
				data?.programmeInfoResponse?.programmeId != null
					? {
							value: String(
								data.programmeInfoResponse.programmeId
							),
							label: data.programmeInfoResponse.programme
					  }
					: null,

			firstSubjectId:
				data?.programmeInfoResponse?.firstSubjectId != null
					? {
							value: data.programmeInfoResponse.firstSubjectId,
							label: data.programmeInfoResponse.firstSubject
					  }
					: null,

			secondSubjectId:
				data?.programmeInfoResponse?.secondSubjectId != null
					? {
							value: data.programmeInfoResponse.secondSubjectId,
							label: data.programmeInfoResponse.secondSubject
					  }
					: null,

			thirdSubjectId:
				data?.programmeInfoResponse?.thirdSubjectId != null
					? {
							value: data.programmeInfoResponse.thirdSubjectId,
							label: data.programmeInfoResponse.thirdSubject
					  }
					: null,

			fourthSubjectId:
				data?.programmeInfoResponse?.fourthSubjectId != null
					? {
							value: data.programmeInfoResponse.fourthSubjectId,
							label: data.programmeInfoResponse.fourthSubject
					  }
					: null,

			utmeScore: data?.programmeInfoResponse?.utmeScore ?? null
		},

		postUtmeEducationHistoryResponse:
			data?.postUtmeEducationHistoryResponse?.length > 0
				? data?.postUtmeEducationHistoryResponse.map((education) => ({
						...education
				  }))
				: [],

		studentTypeId: data?.studentTypeId,

		oLevelResult: {
			sittings: data?.olevelResponse?.map((item) => ({
				...item,
				resultPin: item?.resultPin,
				resultPinSno: item?.resultSerialNumber,
				examNumber: item?.examNumber,
				examCentre: item?.examCenter,
				oLevelType: {
					value: item?.examinationTypeId,
					label: item?.examinationType
				},
				examYear: { value: item?.examYear, label: item?.examYear },
				subjects: [
					...Object?.keys(item?.subjectGrade).map((key, index) => ({
						subject: {
							label: key?.toUpperCase(),
							value: Object?.keys(item?.subjectGradeId)?.[index]
						},
						grade: {
							label: item?.subjectGrade?.[key],
							value: Object?.values(item?.subjectGradeId)?.[index]
						}
					}))
				]
			}))
		},
		certificates:
			data?.certificates?.map((certificate) => ({
				...(certificate.certificateType && {
					certificate: certificate.certificate,
					certificateTypeId: {
						value: certificate.certificateTypeId,
						label: certificate.certificateType
					}
				})
			})) ?? []
	};
};

export const degreeReducer = (state = {}, action) => {
	switch (action.type) {
		case SAVE_DEGREE_INFO:
			return action.payload;
		case CLEAR_APPLICATION_DATA:
			return {};
		default:
			return state;
	}
};
